import Icon from '@mui/material/Icon'
import { styled, useTheme } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { Link } from 'react-router-dom-v5-compat'

import Constants from 'Constants'

import MenuToolTip from '../common/Tooltip'

const { MEDIA_SERVER } = Constants

interface NavIconProps {
  icon?: string
  label?: string
  iconFilter?: string
}

const NavIcon: React.FC<NavIconProps> = ({ icon, label, iconFilter }) => (
  <Icon
    sx={{
      display: 'flex',
      height: 'inherit',
      width: 'inherit',
      mr: 1,
    }}
  >
    <img alt={label} src={MEDIA_SERVER + icon} style={iconFilter ? { filter: iconFilter } : undefined} />
  </Icon>
)

interface StyledTabExtraProps {
  isActive?: boolean
}

const StyledTab = styled(Tab, {
  shouldForwardProp: prop => prop !== 'isActive',
})<StyledTabExtraProps>(({ theme, isActive }) => ({
  textTransform: 'capitalize',
  minHeight: '54px',
  color: theme.palette.background.paper,
  opacity: isActive ? 1 : 0.6,
  '&.Mui-selected': {
    color: theme.palette.background.paper,
    borderBottom: `2px solid ${theme.palette.background.paper}`,
    opacity: 1,
  },
  '& img': {
    filter: 'sepia(100%) saturate(0%) hue-rotate(184deg) brightness(215%) contrast(101%)',
  },
}))

interface NavItemProps {
  label: string
  to: string
  icon?: string
  IconComponent?: React.ElementType
  iconFilter?: string
  isActive?: boolean
  index: number
}

const NavItem: React.FC<NavItemProps> = ({ label, icon, IconComponent, iconFilter, to, isActive = false, index }) => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.only('md'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

  const renderedIcon = IconComponent ? (
    <IconComponent sx={{ mr: 1, fontSize: 20 }} />
  ) : (
    <NavIcon icon={icon} iconFilter={iconFilter} label={label} />
  )

  return (
    <MenuToolTip disableHoverListener={isDesktop} title={label}>
      <StyledTab
        component={Link}
        icon={renderedIcon}
        iconPosition={!isTablet ? 'start' : 'top'}
        isActive={isActive}
        label={!isTablet && label}
        to={to}
        value={index}
      />
    </MenuToolTip>
  )
}

export default NavItem
